import { createSlice } from '@reduxjs/toolkit';
import REDUX_SLICE_NAMES from 'src/const/redux-slice-names';
import { useSelector, useDispatch } from 'react-redux';

const initialState = {
  isLoading: false,
};

export const loadingSlice = createSlice({
  name: REDUX_SLICE_NAMES.LOADING,
  initialState,
  reducers: {
    setLoadingState: (state, action) => {
      if (action && action.payload) {
        state.isLoading = action.payload.isLoading;
      }
    },
  },
});

const { setLoadingState } = loadingSlice.actions;

export const useGetLoadingState = () =>
  useSelector((state) => state[loadingSlice.name]);

export const useSetLoadingState = () => {
  const dispatch = useDispatch();
  const showLoading = () => {
    dispatch(setLoadingState({ isLoading: true }));
  };
  const closeLoading = () => {
    dispatch(setLoadingState({ isLoading: false }));
  };

  return {
    showLoading,
    closeLoading,
  };
};

export default loadingSlice.reducer;
